import Vue from 'vue'
import {
  instance,
  errorService,
  savePreviousData,
  formatCurrency,
} from '@/services/api'
import {
  calculatePerimeterBuildingFootprint,
  showNotification,
} from '@/services/calculate'
import { calculations, socketEvents, validateNumber } from '@/services/config'
import { dropdownAPIs, masterAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import DynamicTable from '@/components/DynamicComponents/Admin/MasterData/Grid'
import InteriorGrouping from '@/components/DynamicComponents/Admin/MasterData/InteriorGrouping'
import axios from 'axios'

export default {
  components: {
    DynamicTable,
    'interior-grouping': InteriorGrouping,
  },
  data: function () {
    return {
      loader: true,
      headStyle: {
        'font-weight': 'bold',
        background: '#333333 !important',
        color: '#ffffff !important',
        padding: '0 10px',
      },
      dropdownData: [],
      groupingList: null,
      loading: false,
      columnDefs: null,
      create: new Vue(),
      bankDetails: null,
      form: {
        id: undefined,
        tenantName: undefined,
        tenantSF: undefined,
        tenantType: undefined,
      },
      rules: {
        tenantName: [
          {
            required: true,
            message: 'Please enter tenant name',
            trigger: 'blur',
          },
        ],
        tenantSF: [
          { required: true, message: 'Please enter tenant SF', trigger: 'blur' },
        ],
        tenantType: [
          {
            required: true,
            message: 'Please select tenant type',
            trigger: 'change',
          },
        ],
      },
      allPannels: [],
      loaderAdd: false,
      showDropdown: false,
      visible: false,
      selectedTab: this.$route.params.id,
      tabList: [
        {
          id: this.$route.params.id,
          label: 'Tenant',
          value: 0,
          key: this.$route.params.id,
        },
      ],
      activeTab: this.$route.params.id,
      fieldName: null,
      fieldLoader: false,
      savePreviousData: savePreviousData,
      tenantSF: null,
      loaderTitle: 'Please wait...',
      area: undefined,
      perimeter: undefined,
      data: [],
      tenantTypeList: [],
      conditionFactorList: [],
      tabKey: undefined,
    }
  },
  mounted() {
    this.$root.$on('showDisplayLoader', this.showDisplayLoader)
    this.$socketHub.$on('message-received', this.messageRecieved)
  },
  beforeDestroy() {
    this.$root.$off('showDisplayLoader', this.showDisplayLoader)
    this.$socketHub.$off('message-received', this.messageRecieved)
  },
  created() {
    this.getDropDownData()
  },
  methods: {
    async getDropDownData() {
      this.dropdownData = []
      Promise.all([this.loadDropdowns(), this.getTenantTypes()])
        .then(
          axios.spread((...responses) => {
            const result = JSON.stringify(
              _.get(responses[0].data, 'result', []),
            )
            this.dropdownData = JSON.parse(result)
            var dropdownData = JSON.parse(result)
            dropdownData.condition_factor.map(e => {
              this.conditionFactorList.push(e)
            })
            this.groupingBankData = this.dropdownData.bank_interior_grouping
            Object.assign(this.dropdownData, { calculation: calculations })
            this.tenantTypeList = _.get(responses[1].data, 'result', [])
            this.loadColumns()
            this.getGroupingById()
          }),
        )
        .catch(errors => {
          errorService(errors)
        })
    },

    getGroupingById() {
      this.tabList = []
      this.allPannels = []
      instance
        .get(masterAPIs.tenantBank.details(this.$route.params.id))
        .then(response => {
          this.form = _.get(response.data, 'result', null)
          this.form.construction_Quality_Factor = _.get(
            response.data.result,
            'constructionQualityFactor',
            undefined,
          )
          this.form.condition_Factor = _.get(
            response.data.result,
            'conditionFactor',
            undefined,
          )
          this.bankDetails = this.form
          Object.assign(this.form, { label: 'Tenant' })
          this.data = _.get(response.data.result, 'takeoffs', [])
          const interiorGroupings = _.get(
            response.data.result,
            'interiorGroupings',
            [],
          )
          this.tenantSF = _.get(response.data, 'result.tenantSF', null)
          this.allPannels.push({
            id: this.form.id,
            label: 'Tenant',
            takeOff: this.data,
            firstRowValues: this.form,
            key: this.$route.params.id,
            isValidTakeoff: this.form.isValidTakeoff,
            isShow: false,
          })
          this.tabList.push({
            id: this.form.id,
            label: 'Tenant',
            value: null,
            key: this.$route.params.id,
          })
          if (interiorGroupings.length > 0) {
            interiorGroupings.forEach(element => {
              this.tabList.push({
                id: element.id,
                label: element.label,
                value: element.value,
                key: element.id + element.label,
              })
              this.allPannels.push({
                id: element.id,
                label: element.label,
                value: element.value,
                takeOff: [],
                firstRowValues: null,
                key: element.id + element.label,
                isValidTakeoff: element.isValidTakeoff,
                isShow: false,
              })
            })
          }
          if (this.selectedTab !== this.$route.params.id) {
            this.callback(this.selectedTab)
          }
          this.loader = false
        })
        .catch(error => {
          this.loader = false
          errorService(error)
        })
    },

    back() {
      this.$router.push('/master/tenant-bank')
    },

    updateTakeOff(takeOff, isSocket, id, isValid) {
      this.$root.$emit('showLoader', false)
      const index = this.allPannels.findIndex(i => i.id === id)
      if (index > -1) {
        this.allPannels[index].takeOff = [...takeOff]
        this.allPannels[index].isValidTakeoff = isValid
      }
    },

    updatePerimeter(field) {
      this.fieldName = field
    },

    loadColumns() {
      this.columnDefs = [
        {
          rowDrag: true,
          headerName: '',
          field: 'display',
          floatingFilter: false,
          width: 3,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          hide: false,
          menuTabs: [],
        },
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: '',
          field: 'isValidTakeoff',
          hide: true,
        },
        {
          headerName: 'Contract',
          field: 'contract',
          cellEditor: 'selectEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: { type: 'dynamicTable' },
          width: 100,
          headerTooltip: 'Contract',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          editable: false,
        },
        {
          headerName: 'Category Code',
          field: 'categoryCode',
          cellStyle: { textAlign: 'left' },
          width: 150,
          cellEditor: 'selectEditor',
          headerTooltip: 'Category Code',
          cellRendererParams: { type: 'dynamicTable' },
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          editable: false,
        },
        {
          headerName: 'Additional Description',
          field: 'additionalDescription',
          headerClass: 'header-center',
          cellStyle: { textAlign: 'center' },
          cellEditor: 'textEditor',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            placeholder: 'Additional Description',
          },
          width: 150,
          headerTooltip: 'Additional Description',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Takeoff Description',
          field: 'takeoff',
          cellEditor: 'takeoffSelectEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            name: 'takeoff_Name',
            screen: 'master',
          },
          headerTooltip: 'Takeoff',
          cellRenderer: 'toolTipRenderer',
          width: 400,
        },
        {
          headerName: 'Calculation',
          field: 'calculation',
          cellEditor: 'calculationEditor',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            name: 'calculation',
            dropdownData: calculations,
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Calculation',
          resizable: true,
          sortable: false,
          width: 100,
        },
        {
          headerName: 'Quantity',
          field: 'quantity',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellEditor: 'inputCellEditor',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            placeholder: 'Quantity',
            precision: 0,
            min: 0,
            max: 999999999,
          },
          width: 100,
          headerTooltip: 'Quantity',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Unit',
          field: 'unit',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellEditor: 'selectEditor',
          cellRendererParams: { type: 'dynamicTable' },
          width: 100,
          headerTooltip: 'Unit',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          editable: false,
        },
        {
          headerName: 'Unit Cost',
          field: 'unitCost',
          cellStyle: { textAlign: 'right' },
          cellEditor: 'inputCellEditor',
          cellRenderer: 'costPriceCellRenderer',
          tooltipValueGetter: params => {
            return formatCurrency(params.value)
          },
          cellRendererParams: { type: 'dynamicTable' },
          width: 120,
          headerTooltip: 'Unit Cost',
          suppressSizeToFit: true,
          editable: false,
        },
        {
          headerName: 'Condition Factor',
          field: 'conditionFactor',
          headerClass: 'header-center',
          cellEditor: 'selectEditor',
          wrapText: false,
          filter: 'customFilter',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            dropdownName: 'conditionFactor',
            dropdownData: this.conditionFactorList,
            name: 'conditionFactor',
            width: '350px !important',
            editable: true,
          },
          width: 150,
          headerTooltip: 'Condition Factor',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Multiplier',
          field: 'multiplier',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellEditor: 'inputNumberEditor',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            name: 'multiplier',
            type: 'dynamicTable',
            dataType: 'int',
            precision: 3,
            min: 0,
          },
          width: 100,
          headerTooltip: 'Multiplier',
          suppressSizeToFit: true,
        },
        {
          headerName: 'Action',
          field: 'action',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          sortable: false,
          editable: false,
          cellRenderer: 'actionCellRenderer',
          floatingFilter: false,
          width: 100,
          cellRendererParams: {
            type: 'tenantBank',
            url: masterAPIs.tenantBank.takeoff.delete,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ]
      this.loading = true
    },

    callback(value) {
      this.selectedTab = value
      this.activeTab = value
      const panels = [...this.allPannels]
      const index = this.allPannels.findIndex(i => i.key === value)
      this.loader = true
      this.data = []
      if (value !== this.$route.params.id) {
        instance
          .get(
            masterAPIs.tenantBank.grouping.takeoff.list(
              panels[index].id,
              this.$route.params.id,
            ),
          )
          .then(response => {
            this.allPannels[index].takeOff = []
            panels[index].takeOff = _.get(response.data.result, 'takeoffs', [])
            this.data = panels[index].takeOff
            panels[index].firstRowValues = _.get(response.data, 'result', null)
            this.area = _.get(response.data, 'result.area', undefined)
            this.perimeter = _.get(
              response.data,
              'result.perimeter',
              undefined,
            )
            if (panels[index].firstRowValues) {
              panels[index].firstRowValues.interiorGroupingId =
                panels[index].id
            } else {
              Object.assign(panels[index].firstRowValues, {
                interiorGroupingId: panels[index].id,
              })
            }
            if (panels[index].firstRowValues.tenantSF) {
              panels[index]['firstRowValues']['area'] = _.get(
                response.data,
                'result.tenantSF',
                null,
              )
            }
            this.allPannels = [...panels]
            if (
              this.bankDetails &&
              this.bankDetails.interiorGroupings &&
              this.bankDetails.interiorGroupings.length > 0
            ) {
              const groupIndex = this.bankDetails.interiorGroupings.findIndex(
                i => i.id === panels[index].id,
              )
              if (groupIndex > -1) {
                this.bankDetails.interiorGroupings[groupIndex].area = this.area
                this.bankDetails.interiorGroupings[
                  groupIndex
                ].perimeter = this.perimeter
              }
            }
            this.loader = false
          })
          .catch(error => {
            this.loader = false
            errorService(error)
          })
      } else {
        instance
          .get(masterAPIs.tenantBank.details(this.$route.params.id))
          .then(response => {
            this.allPannels[index]['takeOff'] = []
            panels[index]['takeOff'] = _.get(
              response.data.result,
              'takeoffs',
              [],
            )
            this.data = panels[index]['takeOff']
            panels[index]['firstRowValues'] = _.get(
              response.data,
              'result',
              null,
            )
            panels[index]['firstRowValues'].label = 'Tenant'
            this.allPannels = [...panels]
            this.loader = false
          })
          .catch(error => {
            this.loader = false
            errorService(error)
          })
      }
    },

    handleChange(FieldName, value, type) {
      const currentValue = !value ? '' : value
      const previousValue = window.previousValue ? window.previousValue : ''
      let isValid = true
      if (currentValue) {
        this.fieldName = FieldName
        if (previousValue.toString() !== currentValue.toString()) {
          this.fieldLoader = true
          let req = {}
          switch (FieldName) {
            case 'tenantName':
              req = { tenantName: value }
              break
            case 'tenantSF':
              isValid = validateNumber(value, FieldName, 'Tenant SF')
              if (isValid) {
                this.loader = true
                this.loaderTitle = 'Please wait while updating tenant SF'
                req = {
                  tenantSF: Number(value),
                  perimeter: calculatePerimeterBuildingFootprint(Number(value)),
                }
              } else {
                this.fieldName = undefined
                this.form.tenantSF = previousValue
              }
              break
            default:
              req = {
                tenantType: value,
                tenantTypeId: this.tenantTypeList.find(
                  i => i.tenantType === value,
                ).id,
              }
              break
          }
          if (isValid) {
            instance
              .patch(
                `${masterAPIs.tenantBank.details(this.$route.params.id)}`,
                req,
              )
              .then(res => {
                this.fieldLoader = false
              })
              .catch(err => {
                this.fieldLoader = false
                this.loader = false
                errorService(err)
              })
          }
        }
      }
    },

    loadDropdowns() {
      const req = {
        construction_quality_factor: 0,
        condition_factor: 0,
        takeoff_Grouping: 0,
        bank_interior_grouping: 0,
      }
      return instance.post(dropdownAPIs.dropdown, req)
    },

    // Tenant Type List
    getTenantTypes() {
      return instance.post(masterAPIs.tenantType.list, {
        pageSize: 10000,
        currentPage: 0,
        sortColumn: 'tenantType',
        isAscending: true,
      })
    },

    showGrouping() {
      this.visible = true
    },

    onClose(record, ids, type, key) {
      switch (type) {
        case 'add':
          this.tabList.push({
            id: record.id,
            label: record.label,
            value: record.value,
            area: record.area,
            perimeter: record.perimeter,
            key: record.id + record.label,
          })
          this.allPannels.push({
            id: record.id,
            label: record.label,
            value: record.value,
            area: record.area,
            perimeter: record.perimeter,
            takeOff: [],
            firstRowValues: null,
            key: record.id + record.label,
            isValidTakeoff: record.isValidTakeoff,
            isShow: false,
          })
          this.bankDetails.interiorGroupings.push(record)
          break
        case 'update':
          const tabIndex = this.tabList.findIndex(
            i => i.id === record.id,
          )
          const index = this.allPannels.findIndex(
            i => i.id === record.id,
          )
          this.tabKey = this.allPannels[index].key
          this.tabList[tabIndex].label = record.label
          this.tabList[tabIndex].value = record.value
          this.tabList[tabIndex].key = record.id + record.label
          this.allPannels[index].label = record.label
          this.allPannels[index].value = record.value
          this.allPannels[index].key = record.id + record.label
          break
        case 'delete':
          const panelKey = this.allPannels.find(
            i => i.key === this.selectedTab,
          )
          const isDeleted = ids.some(i => i.id === panelKey.id)
          ids.forEach(element => {
            const tabIndex = this.tabList.findIndex(i => i.id === element)
            const index = this.allPannels.findIndex(i => i.id === element)
            const groupIndex = this.bankDetails.interiorGroupings.findIndex(
              i => i.id === element,
            )
            this.allPannels.splice(index, 1)
            this.tabList.splice(tabIndex, 1)
            this.bankDetails.interiorGroupings.splice(groupIndex, 1)
          })
          if (this.selectedTab !== this.$route.params.id && isDeleted) {
            this.selectedTab = this.$route.params.id
            this.activeTab = this.$route.params.id
            this.callback(this.selectedTab)
          }
          break
        case 'sequence':
          this.loader = true
          this.selectedTab = this.$route.params.id
          this.activeTab = this.$route.params.id
          this.getGroupingById()
          break
        case 'error':
          const groupIndex = this.bankDetails.interiorGroupings.findIndex(
            i => i.id === record.id,
          )
          this.bankDetails.interiorGroupings[groupIndex].value = record.value
          break
        default:
          this.visible = false
          break
      }
    },

    showDisplayLoader(flag, show) {
      if (flag) {
        this.loaderTitle = 'Please wait while updating area'
        this.loader = show
      }
    },

    messageRecieved(message) {
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.bankAreaUpdated) {
        this.loaderTitle = 'Please wait...'
        this.loader = true
        if (this.fieldName === 'tenantSF' || this.fieldName === 'perimeter') {
          this.fieldName = undefined
          this.activeTab = this.$route.params.id
          this.selectedTab = this.$route.params.id
          this.getGroupingById()
        } else if (this.visible) {
          if (this.tabKey === this.selectedTab) {
            this.callback(this.selectedTab)
          } else {
            this.loader = false
          }
          this.tabKey = undefined
        } else {
          this.callback(this.selectedTab)
        }
      } else if (data.EventType === 'Error') {
        this.loaderTitle = 'Please wait...'
        showNotification(
          'error',
          'Socket',
          _.get(data, 'Result.Message', null),
        )
        this.loader = false
      }
    },

    refreshGroupingById() {
      this.tabList = []
      this.allPannels = []
      instance
        .get(masterAPIs.tenantBank.details(this.$route.params.id))
        .then(response => {
          this.form = _.get(response.data, 'result', null)
          this.form.construction_Quality_Factor = _.get(
            response.data.result,
            'constructionQualityFactor',
            undefined,
          )
          this.form.condition_Factor = _.get(
            response.data.result,
            'conditionFactor',
            undefined,
          )
          this.bankDetails = this.form
          Object.assign(this.form, { label: 'Tenant' })
          this.data = _.get(response.data.result, 'takeoffs', [])
          const interiorGroupings = _.get(
            response.data.result,
            'interiorGroupings',
            [],
          )
          this.tenantSF = _.get(response.data, 'result.tenantSF', null)
          this.allPannels.push({
            id: this.form.id,
            label: 'Tenant',
            takeOff: this.data,
            firstRowValues: this.form,
            key: this.$route.params.id,
            isShow: false,
          })
          this.tabList.push({
            id: this.form.id,
            label: 'Tenant',
            value: null,
            key: this.$route.params.id,
          })
          if (interiorGroupings.length > 0) {
            interiorGroupings.forEach(element => {
              this.tabList.push({
                id: element.id,
                label: element.label,
                value: element.value,
                key: element.id + element.label,
              })
              this.allPannels.push({
                id: element.id,
                label: element.label,
                value: element.value,
                takeOff: [],
                firstRowValues: null,
                key: element.id + element.label,
                isShow: false,
              })
            })
          }
          if (this.selectedTab !== this.$route.params.id) {
            this.callback(this.$route.params.id)
          }
          this.loader = false
        })
        .catch(error => {
          this.loader = false
          errorService(error)
        })
    },

    checkValidTab(id, isValid) {
      const index = this.allPannels.findIndex(i => i.id === id)
      if (index > -1) {
        this.allPannels[index].isValidTakeoff = isValid
      }
    },
  },
}
